import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL_HREF, WHATSAPP_HREF } from "@/lib/contact";
import { track } from "@/lib/analytics";

/**
 * Mobile-only sticky bottom bar with TWO CTAs (Call + WhatsApp).
 * Hidden on md+ (>=768px) viewports.
 */
export default function StickyCallBar() {
  return (
    <div
      data-testid="sticky-bottom-bar"
      className="md:hidden fixed inset-x-0 bottom-0 z-50 bg-navy/95 backdrop-blur-md border-t border-white/10 px-3 py-2.5 flex items-stretch gap-2 shadow-2xl"
      role="region"
      aria-label="Pulsanti contatto rapido"
    >
      <a
        href={PHONE_TEL_HREF}
        onClick={() => track.phoneCall("sticky_bottom")}
        data-testid="sticky-bottom-call"
        aria-label={`Chiama ora ${PHONE_DISPLAY}`}
        className="flex-1 flex flex-col items-center justify-center gap-0.5 rounded-xl bg-brand-orange text-white px-3 py-2 font-bold animate-pulse-ring btn-glow-orange leading-tight"
      >
        <span className="flex items-center gap-2 text-base">
          <Phone className="h-5 w-5" />
          Chiama Ora
        </span>
        <span className="font-mono text-[11px] tracking-tight opacity-95">{PHONE_DISPLAY}</span>
      </a>
      <a
        href={WHATSAPP_HREF}
        onClick={() => track.whatsapp("sticky_bottom")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-bottom-whatsapp"
        aria-label="Scrivici su WhatsApp"
        className="w-[40%] flex flex-col items-center justify-center gap-0.5 rounded-xl bg-whatsapp text-white px-3 py-2 font-bold btn-glow-green leading-tight"
      >
        <span className="flex items-center gap-2 text-base">
          <MessageCircle className="h-5 w-5" />
          WhatsApp
        </span>
        <span className="text-[11px] opacity-95">Risposta rapida</span>
      </a>
    </div>
  );
}
